import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { SomethingWentWrongErrorFallback } from './SomethingWentWrongErrorFallback';
import { ErrorCodes } from 'src/common/responseCodes';
import { loginRedirect } from 'src/auth/AuthApi/authApi';

type SomethingWentWrongErrorBoundaryProps = {
  children: React.ReactNode;
  ignoreErrorMessages?: string[];
};

export const SomethingWentWrongErrorBoundary = ({
  children,
  ignoreErrorMessages,
}: SomethingWentWrongErrorBoundaryProps) => {
  return (
    <ErrorBoundary
      FallbackComponent={SomethingWentWrongErrorFallback}
      onError={(error) => {
        if (ignoreErrorMessages?.includes(error.message)) {
          throw error;
        }

        if (error.message === ErrorCodes.AccessDenied) {
          loginRedirect();
        }
      }}
    >
      {children}
    </ErrorBoundary>
  );
};
